import ApiService from "@/common/api/api.service";

let endpoint = "Proposta";

const Entregaveis = {

    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    buscar(id) {
        return ApiService.get(`${endpoint}/entregavel?propostaId=${id}`);
    },

    salvar(form) {
        if(form.entregavelId){
            return ApiService.put(`${endpoint}/entregavel`, form);
        }else{
            return ApiService.post(`${endpoint}/entregavel`, form);
        }
    },

    deletar(form) {
        return ApiService.delete(`${endpoint}/entregavel`, form);
    }
}

export default Entregaveis;